import { PlanDetails } from '.'

export function getInitialCurrentPlan(
  plans: PlanDetails[],
  queryStringTaxValue?: string
) {
  const [defaultPlan] = plans

  if (!queryStringTaxValue) {
    return plans.find((plan) => plan.isDefault) || defaultPlan
  }

  return (
    plans.find((plan) => plan.queryStringTaxValue === queryStringTaxValue) ||
    defaultPlan
  )
}
